export const FIREBASE_CONFIG_PATHS = {
  MASTER_CONFIG: 'master/config',
  MIGRATION_TRACKING: 'master/migrationTracking'
};

export const DEFAULT_MASTER_CONFIG = {
  currentActiveYear: new Date().getFullYear(),
  membershipSettings: {
    renewalPeriod: {
      start: '2025-12-01',
      end: '2026-01-31'
    },
    applicationIdFormat: '{uid}-{year}',
    defaultPaymentPeriods: ['annual', 'quarterly'],
    quarters: [
      {
        name: 'Q1',
        startDate: '01/01',
        endDate: '31/03',
        invoiceDate: null
      },
      {
        name: 'Q2',
        startDate: '01/04',
        endDate: '30/06',
        invoiceDate: '01/03'
      },
      {
        name: 'Q3',
        startDate: '01/07',
        endDate: '30/09',
        invoiceDate: '01/06'
      },
      {
        name: 'Q4',
        startDate: '01/10',
        endDate: '31/12',
        invoiceDate: '01/09'
      }
    ]
  },
  migrationFlags: {
    dualWriteEnabled: false,
    legacyReadsEnabled: true,
    cpdMigrationComplete: false,
    invoiceMigrationComplete: false,
    applicationMigrationComplete: false
  },
  lastUpdated: new Date().toISOString()
};

export const DEFAULT_MIGRATION_TRACKING = {
  backfillProgress: {
    applications: {
      totalMembers: 0,
      processedMembers: 0,
      startedAt: null,
      completedAt: null,
      errors: []
    },
    cpdMigration: {
      totalRecords: 0,
      processedRecords: 0,
      startedAt: null,
      completedAt: null,
      errors: []
    },
    invoiceEnrichment: {
      totalInvoices: 0,
      processedInvoices: 0,
      startedAt: null,
      completedAt: null,
      errors: []
    },
    invoiceLinking: {
      totalLinks: 0,
      processedLinks: 0,
      startedAt: null,
      completedAt: null,
      errors: []
    }
  },
  parityChecks: {
    lastRun: null,
    results: {
      invoiceCountMismatch: [],
      cpdCountMismatch: [],
      orphanedInvoices: []
    }
  }
};
